import React, { useMemo } from "react";

import modStyl from "./index.module.scss";
import { useHistory } from "react-router-dom";
import LazyIcon from "../lazy-icon";

type DockItemProps = {
  label: string
  href: string
  icons: React.ReactElement[]
};
const DockItem: React.FC<DockItemProps> = ({ label, icons, href }) => {
  const his = useHistory();

  const [icon, clsName] = useMemo(()=> {
    if (href === his.location.pathname) {
      return [icons[1], `${modStyl.item} ${modStyl.active}`]
    }
    return [icons[0], modStyl.item];
  }, [his.location.pathname])

  return (
    <button onClick={()=> his.replace(href)} className={clsName} type="button">
      {icon}
      <span>{label}</span>
    </button>
  );
};

type Props = {};
const Dock: React.FC<Props> = () => {
  const tabs = [
    {
      key: "home",
      label: "工作台",
      icons: [<LazyIcon name="home" />, <LazyIcon name="home-light" />],
      href: "/v2/home",
    },
    {
      key: "patient",
      label: "我的患者",
      icons: [<LazyIcon name="patient" />, <LazyIcon name="patient-light" />],
      href: "/v2/patient",
    },
    {
      key: "my",
      label: "个人中心",
      icons: [<LazyIcon name="my" />, <LazyIcon name="my-light" />],
      href: "/v2/profile",
    },
  ]

  return (
    <div className={modStyl.wrapper}>
      {tabs.map((item) => <DockItem {...item} />)}
    </div>
  );
};

export default Dock;
